import "./css/app.scss";

/* -----------------------------------------
  IMPORT JS
----------------------------------------- */

// Utility
import browserClasses from "./js/utils/bowser";
import lazyLoad from "./js/utils/lazy";
import { isInView, isInViewVideo } from "./js/utils/inview";
import windowHeightInit from "./js/utils/window-height";

// Components
import cPopup from "./js/components/c-popup";
import cTabs from "./js/components/c-tabs";
import cToggleBlock from "./js/components/c-toggle-block";
import cMenuInit from "./js/components/c-menu";
import cMenuMoreInit from "./js/components/c-menu-more";
import cHeaderInit from "./js/components/c-header";
import cFooterInit from "./js/components/c-footer";
import cContactFormInit from "./js/components/c-contact-forms";
import cTogglesInit from "./js/components/c-toggles";
import GatedContentPopup from "./js/components/gated-content-popup";

// Blocks
import cListDropdownImageInit from "./js/blocks/c-list-dropdown-image";
import cSliderApproachInit from "./js/blocks/c-slider-approach";
import cFeaturedCasesInit from "./js/blocks/c-featured-cases";
import cImageSliderInit from "./js/blocks/c-image-slider";
import cTalentsSliderInit from "./js/blocks/c-talents-slider";
import cFindTeamSlider from "./js/blocks/c-find-team-slider";

// Pages
//import this from './js/pages/home'
import cPostSwiperInit from "./js/pages/insights";
import cSingleJobInit from "./js/pages/single-job";
import cMoreCasesSwiperInit from "./js/pages/single-case";
import cCertificate from "./js/components/c-certificate";
import { initTabs } from "./js/utils/tab";
import calculatorInit from "./js/components/c-calculator";

/* -----------------------------------------
  INIT
----------------------------------------- */

const initScripts = {
  init: function () {
    // Utility
    browserClasses();
    lazyLoad();
    isInView();
    isInViewVideo();
    windowHeightInit();

    // Components
    cPopup();
    cTabs();
    cToggleBlock();
    cMenuInit();
    cMenuMoreInit();
    cHeaderInit();
    cFooterInit();
    cContactFormInit();
    cImageSliderInit();
    cTogglesInit();
    cTalentsSliderInit();
    cCertificate();

    // Blocks
    cListDropdownImageInit();
    cSliderApproachInit();
    cFeaturedCasesInit();
    cFindTeamSlider();

    // Pages
    // this()
    cPostSwiperInit();
    cSingleJobInit();
    cMoreCasesSwiperInit();

    GatedContentPopup().init();

    initTabs();

    calculatorInit();
  },
};
initScripts.init();
